import img1 from '../images/gallery/Corridor-1.jpeg';
import img2 from '../images/gallery/Corridor-2.jpeg';
import img3 from '../images/gallery/Corridor-4.jpeg';
import img4 from '../images/gallery/Corridor-3.jpeg';
import img5 from '../images/gallery/View from room.jpg';
import img6 from '../images/gallery/Front desk.jpeg';
import img7 from '../images/gallery/Exterior-1.jpg';
import img8 from '../images/gallery/Gym Refresh.jpeg';
import img9 from '../images/gallery/Gym-1.jpeg';
import img10 from '../images/gallery/Gym-2.jpg';
import img11 from '../images/gallery/Gym-3.jpg';
import img12 from '../images/gallery/Kitchen-1.jpeg';
import img13 from '../images/gallery/Kitchen-2.jpeg';
import img14 from '../images/gallery/Kitchen-3.jpeg';
import img15 from '../images/gallery/Kitchen-4.jpeg';
import img16 from '../images/gallery/Lobby-2.jpeg';
import img17 from '../images/gallery/Lobby-3.jpg';
import img18 from '../images/gallery/Lobby-4.jpeg';
import img19 from '../images/gallery/Lobby-5.jpeg';
import img20 from '../images/gallery/Lobby-6.jpeg';
import img21 from '../images/gallery/Pool Area-2.jpg';
import img22 from '../images/gallery/Shower-1.jpeg';
import img23 from '../images/gallery/Shower-3.jpeg';
import img24 from '../images/rooms/Living Room-2.jpeg';
import img25 from '../images/rooms/Living Room-1.jpeg';
import img26 from '../images/rooms/Living Room-3.jpeg';
import img27 from '../images/rooms/Living Room-4.jpeg';
import img28 from '../images/rooms/Living Room-5.jpeg';
import img29 from '../images/rooms/Living Room-6.jpeg';
import img30 from '../images/rooms/Living Room-7.jpeg';
import img31 from '../images/rooms/Living Room-8.jpeg';
import img32 from '../images/gallery/Bahrain Formula 1 International Circuit.webp';
import img33 from '../images/gallery/Bahrain Forts.jpg';
import img34 from '../images/gallery/Bahrain Shopping.jpg';
import img35 from '../images/gallery/Bahrain Souq.jpg';
import img36 from '../images/gallery/bahrain-National-Museum.jpg';
import img37 from '../images/gallery/bahrain-World-Trade-Center.jpg';
import img38 from '../images/gallery/Tree-of-Life-Bahrain-1.jpg.webp';





export const gallery = [

    {
        id: 1,
        title: "Hotel Views",
        images: [img1,img3,img6,img5]
    },
    {
        id: 2,
        title: "Guest Room",
        images: [img24,img25,img26,img27,img28,img29,img30,img31]
    },
    {
        id: 3,
        title: "Features",
        images: [img17,img19,img20,img22]
    },
    {
        id: 4,
        title: "Dining",
        images: [img12,img13,img14,img15]
    },
    {
        id: 5,
        title: "Recreation & Fitness",
        images: [img21,img8,img9,img10,img11]
    },
    {
        id: 6,
        title: "Nearby attractions",
        images: [img32,img33,img34,img35,img36,img37,img38]
    }

]

// [img1,img2,img3,img4,img5,img6,img7,img8],
//     [img9,img10,img11,img12,img13,img14,img15,img16],
//     [img17,img18,img19,img20,img21,img22,img23,img24],
//     [img25,img26,img27,img28,img29,img30,img31],